import { render, staticRenderFns } from "./titlebar.vue?vue&type=template&id=48fe037a&scoped=true&"
import script from "./titlebar.vue?vue&type=script&lang=js&"
export * from "./titlebar.vue?vue&type=script&lang=js&"
import style0 from "./titlebar.vue?vue&type=style&index=0&id=48fe037a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe037a",
  null
  
)

export default component.exports